import React, { useState, useEffect, Fragment } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { IcoPlus, IcoMinusCircled } from '@icons';
import { getNoticesProceduralProgresses } from '@lib/api';
import { translate } from 'components/translation/translation';

const ProceduralProgresses = ({ data, proceduralProgresses, setProceduralProgresses, setOriginProceduralProgresses }) => {
	const [notice, setNotice] = useState(data);

	useEffect(() => {
		if (notice.id) {
			getNoticesProceduralProgresses(notice.id).then((retrievedProceduralProgresses) => {
				if (retrievedProceduralProgresses.success) {
					setProceduralProgresses(retrievedProceduralProgresses.data);
					setOriginProceduralProgresses(retrievedProceduralProgresses.data);
				}
			});
		}
	}, [notice.id, setOriginProceduralProgresses, setProceduralProgresses]);

	const onChange = (e, setSelect, elIndex, list, parentIndex) => {
		let tempNewNotice = { ...notice };

		let tempList = [...list];

		let tempElement = {
			...tempList[elIndex],
			[e.target.name]: e.target.value,
		};

		tempList[elIndex] = tempElement;

		setSelect(tempList); //as setList

		setNotice(tempNewNotice);
	};

	const addElement = (typeArray, setTypeArray) => {
		let tempTypeArray = [...typeArray];

		let objTypeArray = {};

		objTypeArray = { name: '', description: '' };

		tempTypeArray.push(objTypeArray);

		setTypeArray(tempTypeArray);
	};

	const removeElement = (typeArray, setTypeArray, index) => {
		let tempTypeArray = [...typeArray];

		tempTypeArray.splice(index, 1);

		setTypeArray(tempTypeArray);
	};

	const proceduralProgressesRows = (proceduralProgresses, setProceduralProgresses) => {
		let rows = [];

		if (proceduralProgresses) {
			if (proceduralProgresses.length === 0) {
				proceduralProgresses = [{ name: '', description: '' }];
			}

			let lastIndex = proceduralProgresses.length - 1;

			rows = proceduralProgresses.map((el, i) => {
				const isThisRowFilled = el.name ? true : false;

				return (
					<Row className="align-items-center" style={{ marginBottom: '40px' }} key={'proceduralProgresses-' + i}>
						<Col className="col-5">
							<Form.Control
								type="text"
								name="name"
								placeholder={translate('common.placeholder.progressname', 'nome progresso procedurale')}
								value={el.name ?? ''}
								onChange={(e) => onChange(e, setProceduralProgresses, i, proceduralProgresses)}
							/>
						</Col>
						<Col className="col-4">
							<Form.Control
								className="custom-disabled"
								type="text"
								name="description"
								placeholder={translate('common.placeholder.progressdescription', 'descrizione (opzionale)')}
								value={el.description ?? ''}
								onChange={(e) => onChange(e, setProceduralProgresses, i, proceduralProgresses)}
								disabled={!el.name}
							/>
						</Col>
						<Col className="col-2">
							{i === lastIndex ? (
								<Button
									variant="link"
									className="me-3"
									onClick={() => addElement(proceduralProgresses, setProceduralProgresses)}
									disabled={!isThisRowFilled && (!el.name || !el.description)}
								>
									<IcoPlus className="second-color ico-small indicators" />
								</Button>
							) : null}
							<Button variant="link" onClick={() => removeElement(proceduralProgresses, setProceduralProgresses, i)}>
								<IcoMinusCircled className="red-color ico-small indicators" />
							</Button>
						</Col>
					</Row>
				);
			});
		}
		return rows;
	};

	return <>{proceduralProgressesRows(proceduralProgresses, setProceduralProgresses)}</>;
};
export default ProceduralProgresses;
